import { Anchor, Breadcrumbs, Group, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

/** Nagłówek strony: ścieżka (opcjonalnie), tytuł, krótki opis i akcje po prawej. */
export function PageHeader({
  title,
  description,
  actions,
  crumbs,
  badge,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  /** ścieżka nad tytułem, np. [{ label: 'Sprawy', to: '/sprawy' }] */
  crumbs?: { label: string; to?: string }[];
  /** znacznik obok tytułu (stan, numer) */
  badge?: ReactNode;
}) {
  return (
    <Stack gap={6} mb="lg">
      {crumbs && crumbs.length > 0 && (
        <Breadcrumbs separator="›" separatorMargin={6}>
          {crumbs.map((c) =>
            c.to ? (
              <Anchor key={c.label} component={Link} to={c.to} size="sm" c="dimmed">
                {c.label}
              </Anchor>
            ) : (
              <Text key={c.label} size="sm" c="dimmed">
                {c.label}
              </Text>
            ),
          )}
        </Breadcrumbs>
      )}
      <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
        <Stack gap={4} style={{ flex: '1 1 360px', minWidth: 0 }}>
          <Group gap="sm" wrap="wrap">
            <Title order={2}>{title}</Title>
            {badge}
          </Group>
          {description && (
            <Text c="dimmed" size="sm" maw={760}>
              {description}
            </Text>
          )}
        </Stack>
        {actions && (
          <Group gap="xs" wrap="wrap">
            {actions}
          </Group>
        )}
      </Group>
    </Stack>
  );
}
